import React, { useContext, useEffect, useState } from "react";
import { apiGet } from "../../utils/apiFetch";
import apiPath from "../../utils/apiPath";
import { useTranslation } from "react-i18next";
import AuthContext from "context/AuthContext";
import Pagination from "../Pagination";
import { isEmpty } from "lodash";
import { BiArrowBack } from "react-icons/bi";
import { useLocation, useNavigate } from "react-router-dom";
import classNames from "classnames";
import DynamicTable from "../../components/DynamicTable"; // Import DynamicTable
import AddProductModal from "./AddProductModal"; // Import AddProductModal
import EditProductModal from "./EditProductModal"; // Import EditProductModal
import Select from "react-select";

const tabBtnClass =
  "inline-block py-3 px-8 text-md xl:text-lg font-semibold border-b-2";
const tabActiveClass = "border-lime-500 text-lime-500";
const tabBorderNoneClass = "border-transparent";
const TAB_LIST = "list";
const TAB_ADD = "add";

function Product() {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const location = useLocation();
  const { logoutUser, user } = useContext(AuthContext);
  const [paginationObj, setPaginationObj] = useState({
    page: 1,
    pageCount: 1,
    pageRangeDisplayed: 10,
  });
  const [products, setAllProducts] = useState([]);
  const [page, setPage] = useState(1);
  const [pageSize] = useState(10);
  const [item, setItem] = useState("");
  const [isDelete, setIsDelete] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState(null);
  const [filterData, setFilterData] = useState({
    category: "",
    search: "",
    startDate: "",
    endDate: "",
    isReset: false,
    isFilter: false,
  });
  const [sort, setSort] = useState({
    sort_key: "createdAt",
    sort_type: "desc",
  });
  const manager = user?.permission?.find((e) => e.manager === "product") ?? {};
  console.log("manager", manager);
  const [defaultTab, setDefaultTab] = useState(TAB_LIST);
  const [isAddModalOpen, setIsAddModalOpen] = useState(false); // State to manage add modal visibility
  const [isEditModalOpen, setIsEditModalOpen] = useState(false); // State to manage edit modal visibility
  const [selectedProduct, setSelectedProduct] = useState(null); // State to hold the selected product for editing
  const [categories, setCategories] = useState([]);
  const [categorySearch, setCategorySearch] = useState("");
  const [filteredCategories, setFilteredCategories] = useState([]);

  const handleTabClick = (action) => {
    setDefaultTab(action);
  };

  const handlePageClick = (event) => {
    const newPage = event.selected + 1;
    setPage(newPage);
  };

  const getAllProducts = async () => {
    try {
      setIsLoading(true);
      setError(null);

      const response = await apiGet(
        `${apiPath.ListProduct}?page=${page}&limit=${pageSize}&sort_key=${
          sort.sort_key
        }&sort_type=${sort.sort_type}${
          filterData.search ? `&search=${filterData.search}` : ""
        }${filterData.category ? `&category=${filterData.category}` : ""}${
          filterData.startDate ? `&startDate=${filterData.startDate}` : ""
        }${filterData.endDate ? `&endDate=${filterData.endDate}` : ""}`
      );

      const result = response?.data;
      console.log("API Response:", response);

      if (result?.success) {
        setAllProducts(result.results?.docs || []);
        setPaginationObj({
          ...paginationObj,
          page: result.results.page,
          pageCount: result.results.totalPages,
          perPageItem: result.results.docs.length,
          totalItems: result.results.totalDocs,
        });
      } else {
        console.error("API response structure unexpected:", response);
        setError("Failed to load products. Please try again.");
      }
    } catch (error) {
      console.error("Error fetching products:", error);
      setError("Failed to load products. Please try again.");
    } finally {
      setIsLoading(false);
    }
  };

  const getCategories = async () => {
    try {
      const path = apiPath.categoryList;
      const result = await apiGet(path);
      if (result?.status === 200) {
        setCategories(result?.data?.results?.docs || []);
        setFilteredCategories(result?.data?.results?.docs || []);
      }
    } catch (error) {
    }
  };

  const handleSearch = (e) => {
    const value = e.target.value;
    setFilterData((prev) => ({
      ...prev,
      search: value,
      isFilter: true,
    }));
  };

  const handleCategoryChange = (selectedOption) => {
    setFilterData((prev) => ({
      ...prev,
      category: selectedOption?.value || "",
      isFilter: true,
    }));
  };

  const handleReset = () => {
    setFilterData({
      category: "",
      search: "",
      startDate: "",
      endDate: "",
      isReset: true,
      isFilter: false,
    });
  };

  useEffect(() => {
    if (categorySearch) {
      const filtered = categories.filter((category) =>
        category.title.toLowerCase().includes(categorySearch.toLowerCase())
      );
      setFilteredCategories(filtered);
    } else {
      setFilteredCategories(categories);
    }
  }, [categorySearch, categories]);

  useEffect(() => {
    getCategories();
  }, []);

  useEffect(() => {
    getAllProducts();
  }, [page, filterData, sort]);

  if (error) {
    return <div className="p-4 text-red-500">{error}</div>;
  }

  const columns = [
    { key: "product_id", label: t("O_PRODUCT_ID"), sortable: true },
    { key: "product_name", label: t("O_PRODUCT_NAME") },
    {
      key: "category.title",
      label: t("O_CATEGORY"),
      render: (value, row) => row.category?.title || "",
    },
    { key: "bnTitle", label: "Bangla Title" },
    { key: "product_subtitle", label: "Product Subtitle" },
    { key: "bn_sub_title", label: "Product Bangla Subtitle" },
    {
      key: "product_image",
      label: " Product Image",
      render: (value) =>
        value ? (
          <img
            src={
              value.startsWith("http")
                ? value
                : `https://agrigate-app-public.s3.ap-south-1.amazonaws.com/${value}`
            }
            alt="Product"
            className="flex justify-center w-28 h-16 items-center  object-cover"
          />
        ) : null,
    },
    {
      key: "created_at",
      label: t("O_CREATED_AT"),
      render: (value) => new Date(value).toLocaleDateString(),
    },

   
  ];

  const actions = {
    view: true,
    edit: true,
    delete: true,
    onEdit: (product) => {
      setSelectedProduct(product);
      setIsEditModalOpen(true);
    },
  };
  console.log("products", columns);
  return (
    <div className="bg-[#F9F9F9]">
      <div className="">
        <div className="bg-white rounded-lg">
          <div className="pt-4">
            <div className="flex mr-5 justify-between">
              <div className="2xl:ml-auto xl:ml-0 lg:pt-0 pt-2">
                <div className="flex justify-end items-center gap-3">
                  <div className="flex items-center gap-3">
                    <input
                      type="text"
                      placeholder="Search..."
                      value={filterData.search}
                      onChange={handleSearch}
                      className="border border-gray-300 rounded-lg px-4 py-2 focus:outline-none focus:ring-2 focus:ring-LightBlue"
                    />
                    <div className="w-64">
                      <Select
                        value={
                          categories.find((c) => c._id === filterData.category)
                            ? {
                                value: filterData.category,
                                label: categories.find(
                                  (c) => c._id === filterData.category
                                ).title,
                              }
                            : null
                        }
                        onChange={handleCategoryChange}
                        onInputChange={(value) => setCategorySearch(value)}
                        options={[
                          { value: "", label: "All Categories" },
                          ...filteredCategories.map((category) => ({
                            value: category._id,
                            label: category.title,
                          })),
                        ]}
                        placeholder="Select Category"
                        isClearable
                        className="basic-single"
                        classNamePrefix="select"
                        styles={{
                          control: (base) => ({
                            ...base,
                            borderColor: "#E5E7EB",
                            "&:hover": {
                              borderColor: "#E5E7EB",
                            },
                            boxShadow: "none",
                            borderRadius: "0.5rem",
                            minHeight: "42px",
                          }),
                          option: (base, state) => ({
                            ...base,
                            backgroundColor: state.isSelected
                              ? "#3B82F6"
                              : state.isFocused
                              ? "#EFF6FF"
                              : "white",
                            color: state.isSelected ? "white" : "#374151",
                            "&:hover": {
                              backgroundColor: state.isSelected
                                ? "#3B82F6"
                                : "#EFF6FF",
                            },
                          }),
                        }}
                      />
                    </div>
                    <button
                      onClick={handleReset}
                      className="bg-LightBlue text-white px-4 py-2 rounded-lg hover:bg-DarkBlue"
                    >
                      Reset
                    </button>
                  </div>
                  {(manager?.add || user?.role === "admin") && (
                    <button
                      title={"Add Product"}
                      type="button"
                      className="bg-LightBlue flex text-sm px-8 py-2 rounded-lg items-center border border-transparent text-white hover:bg-DarkBlue whitespace-nowrap"
                      onClick={() => setIsAddModalOpen(true)}
                    >
                      + {"Add Product"}
                    </button>
                  )}
                </div>
              </div>
            </div>
            {defaultTab === TAB_LIST ? (
              <div className="p-3">
             
                  <DynamicTable
                    data={products}
                    columns={columns}
                    sort={sort}
                    setSort={setSort}
                    actions={actions}
                    page={page}
                    manager={manager}
                    userRole={user?.role}
                    onStatusChange={() => {}}
                    onDelete={() => {}}
                  />
                
                <div className="mt-4">
                  {paginationObj?.totalItems ? (
                    <Pagination
                      handlePageClick={handlePageClick}
                      options={paginationObj}
                      isDelete={isDelete}
                      page={page}
                    />
                  ) : null}
                </div>
              </div>
            ) : (
              <div className="p-3">{/* Add product form will go here */}</div>
            )}
          </div>
        </div>
      </div>
      <AddProductModal
        isOpen={isAddModalOpen || isEditModalOpen}
        onClose={() => {
          setIsAddModalOpen(false);
          setIsEditModalOpen(false);
          setSelectedProduct(null);
        }}
        product={selectedProduct}
        onSuccess={() => {
          setIsAddModalOpen(false);
          setIsEditModalOpen(false);
          setSelectedProduct(null);
          getAllProducts();
        }}
      />
    </div>
  );
}

export default Product;
